import { useState } from "react";

// Two-tap confirm: first click arms, second confirms. Used for publish,
// unpublish and archive so status changes are always deliberate.
export const ConfirmAction = ({
  label,
  confirmLabel = "Confirm",
  onConfirm,
  testid,
  className = "",
  confirmClassName = "",
}) => {
  const [armed, setArmed] = useState(false);
  if (armed) {
    return (
      <span className="inline-flex items-center gap-2">
        <button
          type="button"
          data-testid={`${testid}-confirm`}
          onClick={() => {
            setArmed(false);
            onConfirm();
          }}
          className={`rounded-sm bg-crimson px-3 py-1.5 text-xs font-bold text-white transition-colors hover:bg-crimson-dark ${confirmClassName}`}
        >
          {confirmLabel}
        </button>
        <button
          type="button"
          data-testid={`${testid}-cancel`}
          onClick={() => setArmed(false)}
          className="rounded-sm border border-navy/20 px-3 py-1.5 text-xs font-bold text-navy transition-colors hover:border-navy"
        >
          Cancel
        </button>
      </span>
    );
  }
  return (
    <button
      type="button"
      data-testid={testid}
      onClick={() => setArmed(true)}
      className={`rounded-sm border border-navy/20 px-3 py-1.5 text-xs font-bold text-navy transition-colors hover:border-navy ${className}`}
    >
      {label}
    </button>
  );
};
